export default "//cloud.imgsmail.ru/cloud.mail.ru/179961/img/build/errors/error-403.png";